<template>
	<div>
		<ReBPEdit v-if="typeof this.$route.params.type=='undefined' && typeof this.$route.params.type_id=='undefined'"
			:bpId="this.$route.params.bp_id"
			:operationType="operationType"/>

		<ReBPStageEdit v-if="this.$route.params.type=='stage'"
			:stageId="this.$route.params.type_id"
			:operationType="operationType"/>

		<ReBPTaskEdit v-if="this.$route.params.type=='task'"
			:taskId="this.$route.params.type_id"
			:operationType="operationType"/>
	</div>
</template>
<script>
import ReBPEdit from 'src/our_components/ReBPEdit.vue';
import ReBPStageEdit from 'src/our_components/ReBPStageEdit.vue';
import ReBPTaskEdit from 'src/our_components/ReBPTaskEdit.vue';

export default {
	name: 'bp_edit-page',
	components: {
		ReBPEdit,
		ReBPTaskEdit,
		ReBPStageEdit
	},
	data() {
		return {
			ApiData: {}
		};
	},
	computed:{
		operationType: function(){
			return location.pathname.indexOf('/add')!=-1?'add':'edit';
		}
	},
	methods: {
		
	},
	mounted() {
		
	}
};
</script>
<style>
</style>
